var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-button",
    {
      attrs: { size: "sm", variant: "success", disabled: _vm.sku == null },
      on: { click: _vm.addToCart },
    },
    [
      _c("span", { staticClass: "material-icons" }, [_vm._v("shopping_cart")]),
      _vm._v("Order Moulding Sample £" + _vm._s(_vm.displayPrice)),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }